module.exports = __webpack_public_path__ + "static/media/check-1.b1464af4.svg";